import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Shield, LogOut, User, LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-blue-600" : "text-slate-700 hover:text-slate-900"}`;

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded bg-slate-900 text-white">
            <Shield className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <div className="font-black text-slate-900 text-base tracking-tight">ALOKA</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Corporate · Legal · Finance</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          <NavLink to="/services" className={linkCls} data-testid="nav-services">Services</NavLink>
          <NavLink to="/tools" className={linkCls} data-testid="nav-tools">Tools</NavLink>
          <NavLink to="/community" className={linkCls} data-testid="nav-community">Community</NavLink>
          <NavLink to="/debate" className={linkCls} data-testid="nav-debate">Debates</NavLink>
          <NavLink to="/about" className={linkCls} data-testid="nav-about">About</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-contact">Contact</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button variant="outline" size="sm" onClick={() => nav("/dashboard")} data-testid="header-dashboard-btn">
                <LayoutDashboard className="w-4 h-4 mr-1" /> Dashboard
              </Button>
              <Button variant="ghost" size="sm" onClick={async () => { await logout(); nav("/"); }} data-testid="header-logout-btn">
                <LogOut className="w-4 h-4 mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => nav("/login")} data-testid="header-login-btn">
                <User className="w-4 h-4 mr-1" /> Login
              </Button>
              <Button size="sm" className="btn-primary" onClick={() => nav("/register")} data-testid="header-register-btn">
                Get Started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
